export const REQUEST_STARTED = 'sub_users_fetch_request_started';
export const REQUEST_SUCCESS = 'sub_users_fetch_request_success';
export const REQUEST_FAILED = 'sub_users_fetch_request_failed';

export default {
  REQUEST_STARTED,
  REQUEST_SUCCESS,
  REQUEST_FAILED,
};
